import { render, staticRenderFns } from "./InvoiceDesignModal.vue?vue&type=template&id=6c23d79d&scoped=true&"
import script from "./InvoiceDesignModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceDesignModal.vue?vue&type=script&lang=js&"
import style1 from "./InvoiceDesignModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c23d79d",
  null
  
)

export default component.exports